import axios from "axios";
import { API_BASE_URL } from "config";
import { condition } from "context/condition";
import { Globalstate } from "context/context";
import { useMutation } from "react-query";

const getBingQna = async ({ id, botKey, source, query }) => {
  const authToken = localStorage.getItem("authToken");
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_BASE_URL}/bing_qna`,
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },
    data: {
      id: id,
      model: process.env.REACT_APP_GPT_MODEL,
      source: source
    },
  };
  try {
    const data = await axios.request(config);
    return {
      data: {
        ...data.data,
        isBingResponse: true,
        question: query,
      },
      key: botKey,
    };
  } catch (err) {
    console.log("Error: ", err);
    return {
      data: {
        question: query,
        answer: "Something Went Wrong! Please Try Again Later",
        cta_results: [],
        recommended_questions: [],
        id: "",
        isBingResponse: true
      },
      key: botKey,
    };
  }
};
/**
 * @description useQna is a custom hook used for asking query to the bot. This is used to make an api call to /qna. the result is then stored in the context. Destrcuture the mutuateAsync function from the hook and pass the value which we need to ask to the bot
 * @returns {function} useMutation function from react-query
 * @example
 * const {mutuateAsync} = useQna();
 * mutateAsync("hi");
 */
const useBingQna = () => {
  const { dispatch } = Globalstate();
  return useMutation(getBingQna, {
    onSuccess: (data) => {
      dispatch({
        type: condition.UPDATEMESSGES,
        payload: {
          key: data?.key,
          data: data.data,
        },
      });
      dispatch({
        type: condition.SETMESSAGESUBMITTED,
        payload: false,
      });
    },
    onError: (error) => {
      console.log("Error: ", error);
      dispatch({
        type: condition.UPDATEMESSGES,
        payload: {
          key: error?.key,
          data: error?.answer,
        },
      });
    },
  });
};

export default useBingQna;
